import React from 'react';
import {Tooltip} from "@mui/material";

const EmailVerifyToolTip = ({title, children, isEmailVerified}) => {
  return (
    <Tooltip title={title} disableHoverListener={isEmailVerified}>
      <div>
        {children}
      </div>
    </Tooltip>
  );
}

export default EmailVerifyToolTip;
